import { render, staticRenderFns } from "./expense-detail.vue?vue&type=template&id=0ed08355&scoped=true"
import script from "./expense-detail.vue?vue&type=script&lang=js"
export * from "./expense-detail.vue?vue&type=script&lang=js"
import style0 from "./expense-detail.vue?vue&type=style&index=0&id=0ed08355&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed08355",
  null
  
)

export default component.exports